import { useQuery } from '@tanstack/react-query'
import { useApi } from './useApi'

const fetchEnvironmentConfig = async (
  id: string,
  chainId: string,
  callApi: any
): Promise<Environment[]> => {
  const response = await callApi<any>(`/environments/config/${id}/${chainId}`)

  return response
}


export const useEnvironmentConfig = (
  id: string,
  chainId: string
) => {
  const { callApi } = useApi()

  return useQuery<any>({
    queryKey: ['environmentConfig', id, chainId],
    queryFn: () => fetchEnvironmentConfig(id, chainId, callApi),
  })
}
